// extracted by mini-css-extract-plugin
export default {"SubredditSkeleton":"Subreddit_SubredditSkeleton__3l2Hy"};